import { combineReducers } from 'redux';
import answers from './answers'
import questionInfo from './questionInfo';
import session from './session';
import estimator from './estimator'

export default combineReducers ({
    answers, questionInfo, session, estimator
})